import { ModalProps } from "antd";
import ModalWithBorders from "components/ModalWithBorders";
import useIsMobile from "hooks/useIsMobile";

const ResponsiveModal = (props: ModalProps) => {
  const isMobile = useIsMobile();

  const mobileProps: Partial<ModalProps> = {
    centered: false,
    width: "100vw",
    style: { top: 0, padding: 0, margin: 0, maxWidth: "100vw" },
    styles: {
      content: {
        display: "flex",
        flexDirection: "column" as const,
        height: "100vh",
        borderRadius: 0,
      },
      body: {
        flexGrow: 1,
        overflowY: "auto" as const,
        padding: "16px 24px", // Match ThemeSelectionModal padding
      },
      header: { flexShrink: 0 },
      footer: { flexShrink: 0 },
    },
  };

  const desktopProps: Partial<ModalProps> = {
    centered: true,
    width: "90vw", // Default large width, can be overridden by props
    style: { maxWidth: 1400 }, // Default max width, can be overridden by props
    styles: {
      content: {
        display: "flex",
        flexDirection: "column" as const,
        height: "90vh",
        maxHeight: "calc(100vh - 40px)",
      },
      body: {
        flexGrow: 1,
        overflowY: "auto" as const,
        padding: "16px 24px", // Match ThemeSelectionModal padding
      },
      header: { flexShrink: 0 },
      footer: { flexShrink: 0 },
    },
  };

  const responsiveProps = isMobile ? mobileProps : desktopProps;

  // Combine responsive styles with any custom styles passed in props
  const combinedStyles = {
    ...responsiveProps.styles,
    ...props.styles,
  };

  const combinedStyle = {
    ...responsiveProps.style,
    ...props.style,
  };

  return (
    <ModalWithBorders
      {...responsiveProps}
      {...props} // Passed props override defaults (e.g., width, style)
      styles={combinedStyles}
      style={combinedStyle}
    />
  );
};

export default ResponsiveModal;
